import { useMachine } from "@/queries/machine/use-machine";
import { signal } from "./message";
import { useSignal } from "./use-signal";
import { useQueryClient } from "@tanstack/react-query";
import { WorkOrderOperationId } from "@/queries/work-order/use-work-order-operation-id";
import { workOrderKeys } from "@/queries/work-order/work-order-keys";
import { ODataCollectionResponseV4 } from "@odata2ts/odata-core";
import { useInsertScanDiagnostic } from "@/queries/tasks/use-insert-scan-diagnostic";

interface OnStartWOOSerialized {
  EquipmentNId: string;
  IsAutomatic?: boolean;
  EnvelopeTag: string;
  EnvelopeTopic: string;
  EnvelopeModule: string;
  EnvelopeCategory: string;
  EnvelopeUserField1: string;
  EnvelopeUserField2: string;
  EnvelopeUserField3: string;
  EnvelopeUserField4: string;
  EnvelopeUserField5: string;
  EnvelopeUserField6: string;
  EnvelopeUserField7: string;
  EnvelopeUserField8: string;
  EnvelopeUserField9: string;
  EnvelopeUserField10: string;
  WorkOrderOperationId: string;
  SerialNumberCodeList: Array<string>;
  SetPointParameterType: Array<{
    SetPointId: string;
    SetPointItemId: string;
    SetPointItemValue: string;
  }>;
}

function startWOOSerialized(machineId: string) {
  return signal<{ d: [OnStartWOOSerialized] }>({
    app: "AppU4DM",
    channel: "OnStartWorkOrderOperationSerialized",
    filters: `EquipmentNId eq '${machineId}'`,
    enabled: !!machineId,
  });
}

export function useStartWOOSerializedSignal() {
  const { machine } = useMachine();
  const queryClient = useQueryClient();
  const { sendInsertScanDiagnostic } = useInsertScanDiagnostic();

  const machineId = machine?.EquipmentNId;
  const wooIdKey = workOrderKeys.getOperationId(machineId!);

  const sendDiagnostics = (
    mtus: OnStartWOOSerialized["SerialNumberCodeList"]
  ) => {
    const timestamp = new Date();
    mtus.forEach((mtu) => {
      sendInsertScanDiagnostic({
        type: "Received_OnStartWorkOrderOperationSerialized",
        mtu,
        timestamp,
      });
    });
  };

  return useSignal(startWOOSerialized(machineId!), ({ d }) => {
    const [msg] = d;

    queryClient.setQueryData<ODataCollectionResponseV4<WorkOrderOperationId>>(
      wooIdKey,
      () => {
        return {
          value: [
            {
              Id: "na",
              WorkOrderOperation_Id: msg.WorkOrderOperationId,
              WorkOrderOperation: {
                Status: {
                  StateMachineNId: "WorkOrderOperationLifecycle",
                  StatusNId: "Active",
                },
              },
            },
          ],
        };
      }
    );

    sendDiagnostics(msg.SerialNumberCodeList);

    // In case of a new order recieved invalidate all, as potentially every can be changed
    queryClient.invalidateQueries();
  });
}
